// @vite-ignore 
import * as jQuery from '../../lib/jquery/jquery-3.1.1.min.js';
const $ = jQuery

$(document).ready(function () {
    // If we have image maps in our HTML document then we should load the highlight and resize libraries.
    var imageMaps = $('img[usemap]');

    if (imageMaps.length > 0) {
        // Dynamic import for the required libraries
        import('../../lib/maphighlight/jquery.maphilight.min.js')
            .then(() => import('../../lib/rwdImageMaps/jquery.rwdImageMaps.min.js'))
            .then(() => {
                /**
                 * Responsive highlighted image maps
                 */
                $('img[usemap]').rwdImageMaps();
                $('img[usemap]').maphilight();
            });
    }
});
